//combines all application reducers
import {combineReducers} from 'redux'
//replace template with something real
import template from './templateReducer'

export default combineReducers({
    template
})